import { render, staticRenderFns } from "./CustomizeMetalAS.vue?vue&type=template&id=611f8578&scoped=true"
import script from "./CustomizeMetalAS.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAS.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAS.vue?vue&type=style&index=0&id=611f8578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611f8578",
  null
  
)

export default component.exports